/** Локальное обновление строки кампании после сохранения стратегии (без полной перезагрузки). */
export function patchCampaignWithStrategySettings(campaign, settings) {
  const campaignId = Number(campaign.advertId || campaign.id);
  if (campaignId !== Number(settings.campaign_id)) return campaign;

  const strategyType = settings.strategy_type ?? campaign.strategy_type;
  const targetVal =
    settings.target_value != null && settings.target_value !== ''
      ? Number(settings.target_value)
      : null;

  const next = {
    ...campaign,
    bidder_enabled: Boolean(settings.bidder_enabled),
    heatmap_bidding_enabled: Boolean(settings.heatmap_bidding_enabled),
    strategy_type: strategyType,
    daily_spend_limit:
      settings.daily_spend_limit != null && settings.daily_spend_limit !== ''
        ? Number(settings.daily_spend_limit)
        : campaign.daily_spend_limit,
    target_cpc: null,
    target_conversion_cost: null,
    target_drr: null,
  };

  if (strategyType === 'target_cpc' || strategyType === 'cpc') {
    next.target_cpc = targetVal;
  } else if (
    strategyType === 'conversion_cost'
    || strategyType === 'cpo'
    || strategyType === 'cart_cost'
    || strategyType === 'threshold_scout'
  ) {
    next.target_conversion_cost = targetVal;
  } else if (strategyType === 'drr') {
    next.target_drr = targetVal;
  }

  return next;
}
